// What alerts does each usertype deal with and how are they styled in the app

import AlertType from "../Alerts/AlertType";
import VesselColour from "../Enums/VesselColour";

const config = (alertType, vesselColour) => {
	return {
		alertType: alertType,
		vesselColour: vesselColour
	};
};

export default {
	geollect: [
		config(AlertType.NONE, VesselColour.WHITE),
		config(AlertType.ERI, VesselColour.MAGENTA),
		config(AlertType.LRI, VesselColour.SALMON),
		config(AlertType.EEZ, VesselColour.DARKRED), // EEZ/ETW are shared colours. We ran out!! User should use Alert Filters.
		config(AlertType.LEZ, VesselColour.GRAY),
		config(AlertType.ETW, VesselColour.DARKRED),
		config(AlertType.LTW, VesselColour.GRAY),
		config(AlertType.PCS, VesselColour.LIGHTRED),
		config(AlertType.LPO, VesselColour.LIGHTBLUE),
		config(AlertType.O22H, VesselColour.BROWN),
		config(AlertType.RIM, VesselColour.BROWN),
		config(AlertType.O7D, VesselColour.BLACK),
		config(AlertType.O1D, VesselColour.DARKBLUE),
		config(AlertType.O2D, VesselColour.VIOLET),
		config(AlertType.ABO, VesselColour.DARKGREEN),
		config(AlertType.CAS, VesselColour.YELLOW),
		config(AlertType.MYF, VesselColour.PURPLE),
		config(AlertType.STS, VesselColour.ORANGE),
		config(AlertType.NBY, VesselColour.VIOLET)
	],
	london: [
		config(AlertType.NONE, VesselColour.WHITE),
		config(AlertType.ERI, VesselColour.MAGENTA),
		config(AlertType.LRI, VesselColour.SALMON),
		config(AlertType.EEZ, VesselColour.MAGENTA),
		config(AlertType.ETW, VesselColour.DARKRED),
		config(AlertType.LTW, VesselColour.GRAY),
		config(AlertType.PCS, VesselColour.LIGHTRED),
		config(AlertType.LPO, VesselColour.LIGHTBLUE),
		config(AlertType.O22H, VesselColour.BROWN),
		config(AlertType.O1D, VesselColour.DARKBLUE),
		config(AlertType.O2D, VesselColour.VIOLET),
		config(AlertType.O7D, VesselColour.BLACK),
		config(AlertType.ABO, VesselColour.DARKGREEN),
		config(AlertType.CAS, VesselColour.YELLOW),
		config(AlertType.STS, VesselColour.ORANGE)
	],
	west: [
		config(AlertType.NONE, VesselColour.WHITE),
		config(AlertType.ERI, VesselColour.MAGENTA),
		config(AlertType.ETW, VesselColour.DARKRED),
		config(AlertType.LTW, VesselColour.GRAY),
		config(AlertType.PCS, VesselColour.LIGHTRED),
		config(AlertType.LPO, VesselColour.LIGHTBLUE),
		config(AlertType.O2D, VesselColour.VIOLET),
		config(AlertType.O7D, VesselColour.BLACK),
		config(AlertType.ABO, VesselColour.DARKBLUE),
		config(AlertType.CAS, VesselColour.PURPLE),
		config(AlertType.STS, VesselColour.ORANGE),
		config(AlertType.MYF, VesselColour.YELLOW)
	],
	standard: [
		config(AlertType.NONE, VesselColour.WHITE),
		config(AlertType.ERI, VesselColour.MAGENTA),
		config(AlertType.ETW, VesselColour.DARKRED),
		config(AlertType.EEZ, VesselColour.DARKRED),
		config(AlertType.O7D, VesselColour.BLACK),
		config(AlertType.O1D, VesselColour.BROWN),
		config(AlertType.ABO, VesselColour.DARKBLUE),
		config(AlertType.CAS, VesselColour.PURPLE),
		config(AlertType.STS, VesselColour.ORANGE),
		config(AlertType.PCS, VesselColour.LIGHTRED),
		config(AlertType.MYF, VesselColour.YELLOW)
	],
	border_force: [
		config(AlertType.NONE, VesselColour.WHITE),
		config(AlertType.ERI, VesselColour.MAGENTA),
		config(AlertType.EEZ, VesselColour.DARKBLUE),
		config(AlertType.ETW, VesselColour.BLACK),
		config(AlertType.PCS, VesselColour.YELLOW),
		config(AlertType.CAS, VesselColour.PURPLE),
		config(AlertType.STS, VesselColour.ORANGE)
	],
	tdi_brooks: [
		config(AlertType.MYF, VesselColour.PURPLE),
		config(AlertType.DEC, VesselColour.YELLOW),
		config(AlertType.COF, VesselColour.LIGHTRED)
	]
};
